import { removeEmptyValuesInObject } from '@core/helpers'

import { formatPrice } from '../../helpers'

export const productModel = ({
  brand,
  category,
  model,
  name,
  price,
  currency,
  image,
  webUrl,
  mobileDeeplink,
} = {}) => {
  return removeEmptyValuesInObject({
    product_brand: brand,
    product_category: category,
    product_model: model,
    product_name: name,
    product_price: formatPrice({ amount: price, currency }),
    product_image: image,
    product_web_url: webUrl,
    product_mobile_deeplink: mobileDeeplink,
  })
}
